document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.tag--view-all').forEach((el) => {
    el.addEventListener('click', (e) => {
      const id = el.getAttribute('aria-controls');
      const controlled = document.getElementById(id);
      const open = controlled.getAttribute('aria-expanded') === 'false';

      controlled.setAttribute('aria-expanded', !open ? 'false' : 'true');

      document.querySelectorAll(`[aria-controls="${id}"]`).forEach((el) => {
        el.setAttribute('aria-expanded', open ? 'true' : 'false');
        el.innerHTML = open ? '- Show less' : '+ View all';
      });

      e.preventDefault();
      return false;
    });
  });
});
